import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';

@Feature()
export class SearchReplaceFeature extends BaseToolbarFeature {
    id = config.id;
    constructor() {
        super();
    }

    protected getCustomDisabledState(): boolean {
        return this.getAppService().editableServiceLayer?.historyManager.isShown()
        || this.shouldDisableInMaster(config.id);
    }
}
